export default {
  harassment: {
    create: {
      ingress:
        'Tutaj możesz opisać nam szczegółowo sytuację, której byłeś świadkiem, lub której doświadczyłeś w {organizationTitle}. Jesteśmy niezmiernie wdzięczni za pomoc w utrzymaniu bezpieczeństwa w naszym miejscu pracy.',
      instructions:
        'Opisz swoje zgłoszenie w poniższym polu tekstowym. Zdecyduj, czy chcesz dołączyć do zgłoszenia swój adres e-mail, czy zachować anonimowość. Niezależnie od tego, czy zachowasz anonimowość czy nie, po wysłaniu zgłoszenia możesz wrócić i śledzić swoją sprawę.',
      instructions1:
        'Otrzymasz potwierdzenie wysłania zgłoszenia, identyfikator sprawy i hasło, które możesz wykorzystać, niezależnie od tego, czy postanowiłeś zachować anonimowość, czy nie; dzięki temu będziesz mógł później wrócić i kontynuować sprawę.',
      instructions2:
        'Zgłoszenia będą odczytywane przez wyznaczonych administratorów w {organizationTitle}. Żadna inna osoba nie będzie miała wglądu do Twojego zgłoszenia. Jeśli podałeś adres e-mail, zostaniesz powiadomiony o zmianie statusu sprawy. Zachowamy wówczas poufność i nie ujawnimy Twojej tożsamości, jeśli nie będzie to konieczne dla sprawy.',
      instructionsHeader: 'Jak to działa?',
      options: {
        confirmNotToIncludeEmail:
          'Rozumiem, że nie podając swojego adresu e-mail, pozbawiam się możliwości otrzymywania powiadomień o zmianie statusu mojego zgłoszenia, a organizacja przyjmująca nie będzie wiedziała, kim jestem.',
        includeEmail: 'Chcę zamieścić swój adres e-mail'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Ze względów bezpieczeństwa po przesłaniu zgłoszenia utracisz możliwość wglądu i modyfikacji swojego zgłoszenia. Możesz jednak wrócić później i śledzić status sprawy, zapoznać się z ewentualnymi pytaniami uzupełniającymi od {organizationTitle} i uzupełnić dalsze informacje samodzielnie i anonimowo.',
        confirmDescriptionEmailIncluded:
          'Ponieważ zdecydowałeś się podać swój adres e-mail, w przypadku pojawienia się jakichkolwiek pytań po zapoznaniu się przez nas ze sprawą otrzymasz wiadomość na adres {email}. Prosimy sprawdzić raz jeszcze swoje zgłoszenie, zanim je wyślesz.',
        confirmDescriptionEmailNotIncluded:
          'Postanowiłeś nie udostępniać nam swojego adresu e-mail, dlatego kontakt będzie niemożliwy. Sprawdź raz jeszcze swoje zgłoszenie, zanim je wyślesz.',
        createDescription: 'Prosimy zamieścić w tym miejscu opis sprawy:',
        placeholder: 'Chcę zgłosić...',
        reporterGuide: {
          question1: 'Opisz swoją sprawę.',
          question2: 'Kiedy to się wydarzyło?',
          question3: 'Kogo brał w tym udział?',
          question4: 'Gdzie to się wydarzyło?',
          question5: 'Czy podałeś nam wszystkie szczegóły?',
          question6: 'Jeśli chcesz, możesz załączyć zdjęcie',
          title: 'Poradnik przygotowania zgłoszenia'
        },
        responseDescriptionEmailIncluded:
          'Po otwarciu sprawy przez administratora otrzymasz powiadomienie drogą e-mailową.'
      }
    },
    title: 'Zgłoś do {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink: ' Aby przejść dalej, kliknij na ważny link.'
    },
    buttons: {
      back: 'Wróć',
      continue: 'Kontynuuj',
      noOption: 'Nie',
      send: 'Wyślij zgłoszenie',
      yesOption: 'Tak'
    },
    confirm: {
      title: {
        reportNotSent: 'Zgłoszenie NIE zostało wysłane!'
      }
    },
    create: {
      email: {
        help:
          'Jeśli zdecydujesz się zamieścić adres e-mail w swoim zgłoszeniu, skontaktujemy się z Tobą w przypadku aktualizacji statusu lub jakichkolwiek pytań. Dodanie adresu e-mail jest dobrowolne.',
        label: 'Adres e-mail:',
        placeholder: 'Wprowadź swój adres e-mail tutaj'
      },
      ingress:
        'W tym miejscu masz możliwość zgłoszenia niewłaściwego postępowania, o którym wiesz lub podejrzewasz, że przydarzyło się lub przydarzy się w {organizationTitle}. Kanał ten można wykorzystywać wyłącznie do zgłaszania niewłaściwych zachowań w sytuacjach związanych z pracą i tylko w przypadku uzasadnionych podejrzeń, że Twoje informacje są prawdziwe.',
      instructions:
        'W pierwszej kolejności wybierz formę swojego zgłoszenia. Możesz również zdecydować, czy chcesz dołączyć do zgłoszenia swój adres e-mail, czy zachować anonimowość. Niezależnie od tego, czy zachowasz anonimowość czy nie, po wysłaniu zgłoszenia możesz wrócić i śledzić swoją sprawę.',
      instructions1:
        'Otrzymasz potwierdzenie, że zgłoszenie zostało wysłane, a także identyfikator sprawy i hasło, które możesz wykorzystać, niezależnie od tego, czy zachowałeś anonimowość czy nie, aby później wrócić i kontynuować sprawę. Śledzenie sprawy w formie cyfrowej jest możliwe również wtedy, gdy zdecydujesz się na zgłoszenie poprzez kontakt osobisty lub rozmowę telefoniczną.',
      instructions2:
        'Zgłoszenia będą odczytywane przez wyznaczonych administratorów w {organizationTitle}. Żadna inna osoba nie będzie miała wglądu do Twojego zgłoszenia. Jeśli podałeś adres e-mail, zostaniesz powiadomiony o zmianie statusu sprawy. Zachowamy wówczas poufność i nie ujawnimy Twojej tożsamości, jeśli nie będzie to konieczne dla sprawy.',
      instructionsHeader: 'Jak to działa?',
      options: {
        confirmNotToIncludeEmail:
          'Rozumiem, że nie podając adresu e-mail zrzekam się możliwości otrzymywania informacji o aktualizacji statusu mojej sprawy, ponieważ organizacja przyjmująca nie wie, kim jestem.',
        includeEmail: 'Chcę zamieścić swój adres e-mail'
      }
    },
    followup: {
      buttons: {
        submit: 'Zapoznaj się ze sprawą'
      },
      messages: {
        buttons: {
          send: {
            help:
              'Możesz wysłać wiadomość uzupełniającą, która zostanie przeczytana przez przedstawicieli organizacji przyjmującej. Nikt inny nie ma wglądu do Twojej wiadomości.',
            title: 'Wyślij wiadomość'
          }
        },
        messageSent: 'Dziękujemy za wiadomość!',
        placeholder: 'Wpisz wiadomość tutaj',
        reporter: 'Osoba zgłaszająca',
        title: 'Wiadomości',
        writtenByAdmin: 'Administrator'
      },
      status: {
        new: {
          description:
            'Przyjęliśmy Twoje zgłoszenie i wkrótce zapoznamy się z jego treścią.',
          title: 'Nowa wiadomość'
        },
        open: {
          description:
            'Otrzymaliśmy Twoje zgłoszenie i właśnie przeglądamy jego treść. Wkrótce otrzymasz aktualizację statusu. Jeśli udostępniłeś swoje dane kontaktowe, wkrótce otrzymasz wiadomość.',
          title: 'Otwórz'
        },
        solved: {
          description:
            'Twoje zgłoszenie zostało rozpatrzone i zakończono postępowanie. Jeśli udostępniłeś swoje dane kontaktowe, skontaktujemy się z Tobą, aby przekazać Ci dodatkowe informacje.',
          title: 'Rozwiązano'
        }
      },
      statusLabel: 'Status sprawy:',
      title: 'Sprawa {caseName}'
    },
    followupLogin: {
      caseLabel: 'ID sprawy:',
      passwordLabel: 'Hasło:',
      title: 'Dalsze postępowanie w sprawie'
    },
    messages: {
      error: {
        failedToSendReport: 'Nie zdołano wysłać zgłoszenia',
        organizationNotFound:
          'Nie zdołaliśmy znaleźć organizacji, do której można wysłać Twoje zgłoszenie. Upewnij się, że uzyskałeś dostęp przez ważny link.',
        whistleblowerInfoNotFound:
          'Nie zdołano znaleźć informacji o procedurze zgłaszania w tej organizacji'
      }
    },
    received: {
      bottomWarning:
        'Uwaga! To jedyna możliwość wglądu do powyższych informacji, więc zachowaj je teraz!',
      caseLabel: 'ID sprawy:',
      linkLabel: 'Link',
      passwordLabel: 'Hasło:',
      title: 'Otrzymano zgłoszenie!',
      topWarning:
        'Prosimy o bezpieczne przechowywanie i zabezpieczenie poniższych informacji!'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'Ze względów bezpieczeństwa po przesłaniu zgłoszenia utracisz możliwość wglądu i modyfikacji swojego zgłoszenia. Możesz jednak wrócić później i śledzić status sprawy, zapoznać się z ewentualnymi pytaniami uzupełniającymi od {organizationTitle} i uzupełnić dalsze informacje samodzielnie i anonimowo.',
        confirmDescriptionEmailIncluded:
          'Ponieważ zdecydowałeś się podać swój adres e-mail, w przypadku pojawienia się jakichkolwiek pytań po zapoznaniu się przez nas ze sprawą otrzymasz wiadomość na adres {email}. Prosimy sprawdzić raz jeszcze swoje zgłoszenie, zanim je wyślesz.',
        confirmDescriptionEmailNotIncluded:
          'Postanowiłeś nie udostępniać nam swojego adresu e-mail, dlatego kontakt będzie niemożliwy. Sprawdź raz jeszcze swoje zgłoszenie, zanim je wyślesz.',
        createDescription:
          'Opisz, co się stało i dlaczego chcesz to zgłosić. Nie podawaj danych osobowych, chyba że są one istotne dla sprawy.',
        label: 'Chcę dokonać zgłoszenia cyfrowego za pomocą tego formularza',
        placeholder: 'Chcę zgłosić...',
        reporterGuide: {
          question1: 'Opisz swoją sprawę.',
          question2: 'Kiedy to się wydarzyło?',
          question3: 'Kogo brał w tym udział?',
          question4: 'Gdzie to się wydarzyło?',
          question5: 'Czy podałeś nam wszystkie szczegóły?',
          question6: 'Jeśli chcesz, możesz załączyć zdjęcie',
          title: 'Poradnik przygotowania zgłoszenia'
        },
        responseDescriptionEmailIncluded:
          'Gdy sprawa zostanie otwarta przez któregoś z administratorów, otrzymasz powiadomienie e-mail. Nastąpi to w ciągu 7 dni. Po otwarciu sprawy zakończymy postępowanie w ciągu 3 miesięcy.',
        responseDescriptionEmailNotIncluded:
          'Decydując się na zachowanie anonimowości, nie wyraziłeś zgody na otrzymywanie powiadomień e-mailowych o rozpoczęciu sprawy.  Nie będziesz również otrzymywał powiadomień o innych czynnościach związanych ze sprawą. Korzystając z poniższych danych, w dalszym ciągu masz możliwość powrotu i śledzenia statusu sprawy.',
        responseIngress:
          'Dziękujemy za Twoje zgłoszenie! Zajmiemy się Twoją sprawą tak szybko, jak to możliwe.'
      },
      phoneCall: {
        confirmDescription:
          'W kolejnym kroku zobaczysz numer telefonu kontaktowego. Czy na pewno chcesz kontynuować i dokonać zgłoszenia telefonicznego?',
        createDescription:
          'Uzyskasz możliwość dokonania swojego zgłoszenia w postaci wiadomości głosowej.',
        label: 'Chcę dokonać zgłoszenia telefonicznego',
        message:
          '=== Osoba zgłaszająca rozpocznie rozmowę i pozostawi zgłoszenie w postaci wiadomości głosowej. ===',
        responseDescription:
          'W celu dokonania zgłoszenia należy zadzwonić pod poniższy numer telefonu i pozostawić wiadomość głosową:',
        responseInstructions1: 'Zadzwoń pod powyższy numer telefonu',
        responseInstructions2:
          'Postaraj się, by Twoje zgłoszenie zawierało wszystkie szczegóły',
        responseInstructions3:
          'Jeśli chcesz otrzymywać powiadomienia o zmianach statusu sprawy lub nowej korespondencji, podaj w raporcie swój adres e-mail lub numer telefonu.',
        responseInstructions4:
          'Zapisz poniższe informacje, abyś mógł wrócić i śledzić je w tym miejscu.',
        responseInstructionsHeader: 'Instrukcje',
        responseTitle: 'Zgłoś telefonicznie',
        responseWarning:
          'Jeśli nie pozostawisz wiadomości głosowej w ciągu 7 dni, Twoja sprawa zostanie automatycznie zamknięta.'
      },
      physicalMeeting: {
        confirmDescription:
          'Wyślemy do Ciebie wiadomość na adres {email} w sprawie Twojej prośby o ustalenie terminu osobistego spotkania. Chcesz kontynuować?',
        createDescription:
          'Umożliwiamy Ci dokonanie zgłoszenia podczas osobistego spotkania. W tym celu należy podać adres e-mail, który posłuży nam do kontaktu w celu ustalenia terminu spotkania.',
        label: 'Chcę dokonać zgłoszenia w trakcie osobistego spotkania',
        message:
          '== Osoba zgłaszająca poprosiła o ustalenie terminu osobistego spotkania w celu dokonania zgłoszenia. ===',
        responseDescription:
          'Dziękujemy! Otrzymasz od nas propozycję terminu osobistego spotkania, w trakcie którego będziesz mógł dokonać zgłoszenia.  Pamiętaj o zanotowaniu następujących informacji. Będą one potrzebne, jeśli po spotkaniu będziesz chciał kontynuować swoją sprawę.',
        responseTitle: 'Wysłano prośbę o spotkanie'
      }
    },
    title: 'Zgłoś niewłaściwe postępowanie w {organizationTitle}.'
  }
}
